// extracted by mini-css-extract-plugin
export default {"skills-section":"Skills_skills-section__Y76LL","container":"Skills_container__RfoMp"};